import React from 'react';
import { Link } from 'react-router-dom';
import { Plane } from 'lucide-react';

export function Logo() {
  return (
    <Link 
      to="/" 
      className="group flex items-center gap-2 sm:gap-3 text-white hover:text-primary-300 transition-all duration-300"
    >
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-400 to-blue-500 rounded-lg sm:rounded-xl blur-lg opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
        <div className="relative bg-gradient-to-r from-primary-500 to-blue-600 p-2 sm:p-2.5 rounded-lg sm:rounded-xl shadow-lg group-hover:shadow-xl group-hover:scale-105 transition-all duration-300">
          <Plane className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
        </div>
      </div>
      <div className="flex flex-col">
        <span className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-white to-primary-200 bg-clip-text text-transparent">
          AirPortal
        </span>
        <span className="text-[10px] sm:text-xs text-white/60 -mt-1 hidden sm:block">Aviation Services</span>
      </div>
    </Link>
  );
}